/**
 * Human-readable labels for `RevenueModel`, shared by every V2 admin surface
 * that offers the full picker (wizard Step 1 + Step 2, PropertyEditSheet).
 * Was a hardcoded map repeated verbatim in each of those files.
 */
import type { RevenueModel } from "@/types/property";

export const REVENUE_MODEL_LABELS: Record<RevenueModel, string> = {
  full_rent: "Full rent (rent difference)",
  pct_of_rent: "Percentage of rent",
  flat_fee_per_room: "Flat fee per room",
};
